export const SET_PTO_TYPES = 'SET_PTO_TYPES';
export const SET_TIME_OFF_DETAILS = 'SET_TIME_OFF_DETAILS';
export const SET_MY_REQUESTS = 'SET_MY_REQUESTS';
export const SET_PENDING_REQUESTS = 'SET_PENDING_REQUESTS';
export const SET_TEAM_REQUESTS = 'SET_TEAM_REQUESTS';
export const SET_MATER_TIME_OFF_TYPES = 'SET_MATER_TIME_OFF_TYPES';
export const SET_MATER_TIME_OFF_PLANS = 'SET_MATER_TIME_OFF_PLANS';

export const setPtoTypes = (payload: any) => {
  return {
    type: SET_PTO_TYPES,
    payload,
  };
};

export const setMyRequests = (payload: any) => {
  return {
    type: SET_MY_REQUESTS,
    payload,
  };
};

export const setPendingRequests = (payload: any) => {
  return {
    type: SET_PENDING_REQUESTS,
    payload,
  };
};

export const setTeamRequests = (payload: any) => {
  return {
    type: SET_TEAM_REQUESTS,
    payload,
  };
};

export const setTimeOffDetails = (payload: any) => {
  return {
    type: SET_TIME_OFF_DETAILS,
    payload,
  };
};

export const setMasterTimeOffTypes = (payload: any) => {
  return {
    type: SET_MATER_TIME_OFF_TYPES,
    payload,
  };
};

export const setMasterTimeOffPlans = (payload: any) => {
  return {
    type: SET_MATER_TIME_OFF_PLANS,
    payload,
  };
};
